<template>
  <div class="title" v-text="title" />
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
    title: VueTypes.string.isRequired
  }
}
</script>


<style scoped>
.title {
  color: #293845;
  font-size: calc(100vw / 60);
  text-align: center;
}
@media screen and (min-width: 600px) and (max-width: 959px) {
  .title {
    margin-top: 80px;
    margin-bottom: 40px;
  }
}
@media screen and (min-width: 960px) {
  .title {
    margin-top: 80px;
    margin-bottom: 40px;
  }
}
</style>
